import React from 'react'

export default function FormatCurrency(amount) {
    return <>N{amount.toLocaleString()}</>;
}
